import { render, staticRenderFns } from "./valoresCbhpm.vue?vue&type=template&id=0d298ee4&"
import script from "./valoresCbhpm.vue?vue&type=script&lang=js&"
export * from "./valoresCbhpm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports